// extracted by mini-css-extract-plugin
module.exports = {"Presentation":"presentation_Presentation__1Bxb9","avatar":"presentation_avatar__1OyDe"};